import { render, staticRenderFns } from "./latestItem.vue?vue&type=template&id=373b7766&scoped=true&"
import script from "./latestItem.vue?vue&type=script&lang=js&"
export * from "./latestItem.vue?vue&type=script&lang=js&"
import style0 from "./latestItem.vue?vue&type=style&index=0&id=373b7766&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b7766",
  null
  
)

export default component.exports